import React from "react";



const InvestNow = ({handleView}) => {
    return(
        <div className="invest-now">
            <div>
            <h1>
            Grow your<br/>
            money safely
            </h1>
            <button onClick={handleView} className="btn">Get Started</button>
            </div>
        </div>
    )
}

export default InvestNow